import { render, staticRenderFns } from "./ProductoSucursalFiltroProveedor.vue?vue&type=template&id=219b4d39&"
import script from "./ProductoSucursalFiltroProveedor.vue?vue&type=script&lang=js&"
export * from "./ProductoSucursalFiltroProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VChip,VMenu})
